var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"titulo m-0",class:{'texto-azul' : _vm.blue, 'texto-blanco' : _vm.white}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }